import type { ColumnDef } from '@tanstack/react-table';
import type { DetailPointTransactionEntity } from 'services/openapi';
import { subMonths, endOfDay, startOfDay, format } from 'date-fns';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'configs';
import { formatDateTime } from 'utils/helpers/helpers';
import React from 'react';

export type FilterType = {
  startDate: string | number;
  endDate: string | number;
  actorId?: string;
  action?: string | undefined;
  refreshData: number;
  pageSize: number;
  pageIndex: number;
};

export const getInitFilterValues = (urlParams: any): FilterType => {
  return {
    startDate:
      urlParams?.get('startDate') ??
      startOfDay(subMonths(new Date(), 1)).toISOString(),
    endDate: urlParams?.get('endDate') ?? endOfDay(new Date()).toISOString(),
    actorId: urlParams?.get('actorId') ?? '',
    action: urlParams?.get('action') || 'Tất cả',
    refreshData: 0,
    pageSize: Number(urlParams?.get('pageSize') ?? DEFAULT_PAGE_SIZE),
    pageIndex: Number(urlParams?.get('pageIndex') ?? DEFAULT_PAGE_INDEX),
  };
};

export const columnsDefined: ColumnDef<DetailPointTransactionEntity>[] = [
  {
    accessorKey: 'actorPhoneNumber',
    header: 'Tài khoản',
  },
  {
    accessorKey: 'action',
    header: 'Action',
  },
  {
    accessorKey: 'metadata',
    header: 'Metadata',
    cell: (info) => {
      const metadata = info.getValue();
      return <div className='text-xs'>{JSON.stringify(metadata, null, 2)}</div>;
    },
  },
  {
    accessorKey: 'ipAddress',
    header: 'IpAddress',
  },
  {
    accessorKey: 'userAgent',
    header: 'User Agent',
  },
  {
    accessorKey: 'createdAt',
    header: 'Thời gian',
    cell: (info) =>
      format(new Date(String(info.getValue())), 'HH:mm:ss dd/MM/yyyy'),
  },
];

export const convertVariables = (variables: FilterType) => {
  const { startDate, endDate, ...rest } = variables;

  const newTimeFrom =
    typeof startDate === 'string' ? new Date(startDate).getTime() : startDate;
  const newTimeTo =
    typeof endDate === 'string' ? new Date(endDate).getTime() : endDate;

  return {
    ...rest,
    action: rest.action === 'Tất cả' ? '' : rest.action,
    startDate: startDate ? formatDateTime(Number(newTimeFrom)) : '',
    endDate: endDate ? formatDateTime(Number(newTimeTo), true) : '',
  };
};
